
import React, { Fragment } from "react";
import { useState, useEffect, useRef,useMemo } from "react";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { loadSanadBranding } from "../utils/loadSanadBranding";

const { config } = require("../../api/api");

const SanadMotorPolicyRenewal = () => {

     
      //   const [loading, setLoading] = useState(false);
      const [activePriceButton, setActivePriceButton] = useState(null);
      const [isClickedWhatsapp, setIsClickedWhatsapp] = useState(false);
        const base_url = config.baseURL;

        const vendor_key="c3VwZXJqZXRfc2FuYWRfcGVyc29uYWxfYWNjaWRlbnRfdmVuZG9yX2tleQ==";
    
          
        const [quoteDetails,setQuoteDetails]=useState(null);
        const [vehicleDetails,setVehicleDetails]=useState(null);
        const [insuredDetails,setInsuredDetails]=useState(null);
        const [transactionDetails,setTransactionDetails]=useState(null);
        const [openQuoteSummary,setOpenQuoteSummary]=useState(false);
          const [sanadDetails, setSanadDetails] = useState(null);
        
          const quoteRef=useRef(null)
        

      // const handlePriceClick = (buttonId) => {
      //   setActivePriceButton(buttonId);
      // };
    
      const handleWhatsapp = (e) => {
        setIsClickedWhatsapp(e.target.checked);
      };
       const [activeButton, setActiveButton] = useState(null);
      const [loading,setLoading]=useState(false);
        const [openMessageBox,setOpenMessageBox]= useState(false);
        const [message,setMessage]= useState("");
       
        const reg_mark = useMemo(() => [
  "A","A A","A B","A D","A K","A M","A R","A S","A W","A Y",
  "Abu Dhabi","Ajman",
  "B","B A","B B","B D","B H","B K","B M","B R","B S","B W","B Y",
  "Bahrain","BANK",
  "C D",
  "D","D A","D D","D H","D K","D R","D S","D W","D Y",
  "Dubai",
  "Fujairah",
  "H","H A","H D","H H","H K","H M","H R","H S","H W","H Y",
  "I N T L","IMPORT","Inspection",
  "J",
  "K","K A","K B","K H","K K",
  "KSA","Kuwait",
  "L A","L A","L B","L D","L H","L K",
  "M","M A","M B","M D","M H","M K","M L","M M","M R","M S","M W","M Y","MUSCAT",
  "Qatar",
  "R","R A","R H","R K","R M","R R","R S","R W","R Y","Ras Al - Khaimah",
  "S","S H","S S",
  "Sharjah",
  "T","T A","T B","T B A","T D","T H","T T",
  "UAE","Umm Al - Quwain",
  "W","W A","W B","W K","W W",
  "Y","Y A","Y B","Y D","Y M","Y R","Y S","Y W","Y Y",
  "1","2","3","4","5","6","7","8","9",
  "10","11","12","14","15","16","17","18","19",
  "20","21","22","23","24","25","26","27","28","29",
  "30","31","32","33","34","35","36","37","38","39",
  "40","41","42","43","44","45","46","47","48","49",
  "50","51","52","53","54","55","56","57","58","59",
  "60","61","62","63","64","65","66","67","68","69",
  "70","71","72","73","74","75","76","77","78","79",
  "80","81","82","83","84","85","86","87","88","89",
  "90","91","92","999"
], []);
    const [authToken,setAuthToken]=useState("");
const [communicationDetails,setCommunicationDetails]= useState({
    emailChecked:false,
    email:"",
    mobile: "",
    whatsapp:"",
  });

    const [communicationError,setCommunicationError]=useState({
    email:"",
    mobile:"",
    whatsapp:""
  })
    const [premiumAmount,setPremiumAmount]=useState("");
  
  const [isHidePage, setIsHidePage] = useState("");
    const [selectedPlan,setSelectedPlan]=useState("");
  
 const [hoveredCovers, setHoveredCovers] = useState([]);   // store hover covers
  const [showTooltip, setShowTooltip] = useState(false);    // toggle tooltip
  const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });

  const [obtainedCover,setObtainedCover]=useState("");
  const refs={
    Plate_Number:useRef(null),
    // Plate_Code:useRef(null),
    Civil_ID:useRef(null),
    Mobile_Number:useRef(null),
    Quote_No:useRef(null)
  }

   const com_refs={
      mobile:useRef(null),
      whatsapp:useRef(null),
      email:useRef(null)
    }
  
     

    const handlePriceClick = (buttonId,plan) => {

    debugger
    debugger
    setActivePriceButton(buttonId);
    if(plan.premiumAmt){
    setSelectedPlan(plan);
    setPremiumAmount(plan.premiumAmt);
    setObtainedCover(plan.obtainedCvr)
    }
    else{
    setPremiumAmount(plan);
    setObtainedCover(quoteDetails?.obtainedCvr || quoteDetails?.packageDetails?.obtainedCvr)

    }
  };

    useEffect(() => {
      debugger;
      // update sanad data in superjet
      const urlSearchString = window.location.search;
      const uparams = new URLSearchParams(urlSearchString);
      const sanadUserName = uparams.get("SANADUSERNAME");
      const sanadRequesteeName = uparams.get("REQUESTEENAME");
      const sanadUserMobileNumber = uparams.get("REQUESTEEMOBILENO");
      const sanadReferenceNumber = uparams.get("SANADREFNUMBER");
      const sanadCivilIDNumber = uparams.get("REQUESTEECIVILNO");
      const sanadAccessToken = uparams.get("SANADACCESSTOKEN");
      const sanad_ServiceRequestId = uparams.get("SERVICEREQUESTID");
      const sanad_TransDate = uparams.get("TRANSDATE");
      const sanad_ReturnUrl = uparams.get("RETURNURL");
      const sanad_ErrorUrl = uparams.get("ERRORURL");
      const sanad_BackUrl = uparams.get("BACKURL");
      const sanad_Language = uparams.get("LANGUAGE");
  
      let sanad_details = {
        sanad_user_name: sanadUserName,
        sanad_request_name: sanadRequesteeName,
        mobile_no: sanadUserMobileNumber,
        sanad_reference_no: sanadReferenceNumber,
        sanad_civil_no: sanadCivilIDNumber,
        sanad_request_id: sanad_ServiceRequestId,
        trans_date: sanad_TransDate,
        return_url: sanad_ReturnUrl,
        error_url: sanad_ErrorUrl,
        back_url: sanad_BackUrl,
        language: sanad_Language,
      };
  
      if (
        sanadAccessToken ===
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImFkbWluQHNhbmFkLmNvbSIsInBhc3N3b3JkIjoiMTIzNCIsImlhdCI6MTcyODA1MjA0NywiZXhwIjoxNzI4MDUyOTQ3fQ.ucyIy6q6ovSDstXZL1zO-9swTAGYFeypV0uo8_rQJJc"
      ) {
        setIsHidePage("success");
            setFormData((prev)=>({...prev,Mobile_Number:sanad_details.mobile_no,
        Civil_ID:sanad_details.sanad_civil_no
      }))
        setSanadDetails(sanad_details);
      } else {
        setIsHidePage("fail");
      }
      // var sanad_urls_data = {
      //     'back_url': sanad_BackUrl,
      //     'return_url': sanad_ReturnUrl,
      //     'error_url': sanad_ErrorUrl,
      // }
      // debugger
      //    sessionStorage.setItem("sanadUrlData", JSON.stringify(sanad_urls_data));
      // const expiryDate = new Date();
      // expiryDate.setTime(expiryDate.getTime() + (1 * 60 * 60 * 1000));
      // Cookies.set('sanadUrlData', JSON.stringify(sanad_urls_data), { expires: expiryDate });
    }, [activeButton]);
  

    const handleChange = (e) => {
    debugger
  const { name, value } = e.target;
  const trimValue=value.trimStart();

 if(name === "Plate_Number"){
       const numberOnlyRegex = /^[0-9\s]*$/;
// allow empty OR digits
    if (numberOnlyRegex.test(trimValue)) {
      debugger
        setFormData((prev) => ({
        ...prev,
        [name]: trimValue,
      }));
    }
  }
   else if(name === "Full_Name"){
       const numberOnlyRegex = /^[A-Za-z\s]*$/;
// allow empty OR digits
    if (numberOnlyRegex.test(trimValue)) {
      debugger
        setFormData((prev) => ({
        ...prev,
        [name]: trimValue,
      }));
    }
  }
  else{
     setFormData((prev) => ({
        ...prev,
        [name]: trimValue,
      }));
  }
};
      
      
            const handleClick = (buttonId) => {
              setActiveButton(buttonId);

              setFormData({Plate_No:"",Plate_Code:"",Civil_ID:"",Quote_No:"",Mobile_Number:""});
              setError(null);

            }
             
           useEffect(()=>{
              setActiveButton(1)
           },[] )


           const selectOpt1= useRef(null);

           const [formData,setFormData]=useState({
           
           });

           const [error,setError]=useState({});
             const handleValidation = (e) => {
    const { name, value } = e.target;

    if (!value) {
      setError((prev) => ({
        ...prev,
        [name]: name.replace("_", " ") + " is required",
      }));
    } else {
      setError((prev) => ({ ...prev, [name]: "" }));
    }
  };

            const handleValidationRegMark = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (!value || value == "--select--") {
      setError((prev) => ({
        ...prev,
        [name]: name.replace("_", " ") + " is required",
      }));
    } else {
      setError((prev) => ({ ...prev, [name]: "" }));
    }
  };

             useEffect(() => {
               const $select = $(selectOpt1.current);
           
               // Initialize Select2
           
               $select.select2({ width: "100%" });
           
               // Define event handlers
               const handleSelect = (e) => {
                 //  debugger
                 const selectedValue = e.params.data.id;
                 handleValidationRegMark("Plate_Code", selectedValue);
               };
           
               if (formData.passport_country) {
                 $select.val(formData.passport_country).trigger("change");
               }
           
               // Attach handlers
               $select.on("select2:select", (e) => handleSelect(e));
           
               // Cleanup
               return () => {
                 $select.off("select2:select", handleSelect);
                 $select.select2("destroy");
               };
             }, [reg_mark,activeButton]);




             const handleGetQuote=async(e)=>{
               e.preventDefault();
   e.preventDefault();

     setQuoteDetails(null);
            setVehicleDetails(null);
            setInsuredDetails(null);
            setTransactionDetails(null);
            setOpenQuoteSummary(null);
              setPremiumAmount("");
  setActivePriceButton(null);
  setObtainedCover("");
  setCommunicationDetails((prev)=>({
...prev,
    emailChecked:false,
    email:"",
    whatsapp:"",
  }));
  setCommunicationError({
    mobile:"",
    email:"",
    whatsapp:""
  })

               // first validation fields
               let quote_payload;
               let valid=true;
               let focus="";

               if(activeButton===1){


                if(!formData.Plate_Number){
                 setError((err)=>({...err,Plate_Number:"Plate Number is required"}));
                 valid=false;
                 if(!focus){
                  focus="Plate_Number";
                 } 
                }
                if(!formData.Plate_Code){
                 setError((err)=>({...err,Plate_Code:"Plate Code is required"}));
                 valid=false;
                if(!focus){
                  focus="Plate_Code";
                 } 
                }
                if(!formData.Civil_ID){
                setError((err)=>({...err,Civil_ID:"Civil ID is required"}));
                valid=false;
                 if(!focus){
                  focus="Civil_ID";
                 } 
                }
              

               }
               else if(activeButton ===2){
                 if(!formData.Plate_Number){
                 setError((err)=>({...err,Plate_Number:"Plate Number is required"}));
                 valid=false;
                 if(!focus){
                  focus="Plate_Number";
                 } 
                }
                if(!formData.Plate_Code){
                 setError((err)=>({...err,Plate_Code:"Plate Code is required"}));
                 valid=false;
                if(!focus){
                  focus="Plate_Code";
                 } 
                }
                if(!formData.Mobile_Number){
                setError((err)=>({...err,Mobile_Number:"Mobile Number is required"}));
                valid=false;
                 if(!focus){
                  focus="Mobile_Number";
                 } 
                }
               }
               else if(activeButton===3){

                 if(!formData.Quote_No){
                setError((err)=>({...err,Quote_No:"Quote No is required"}));
                valid=false;
                  if(!focus){
                  focus="Quote_No";
                 } 
                }
               }
                 if(focus){
                  if(refs[focus] && refs[focus]?.current){
                     refs[focus].current.focus();
                  }
                }

               if(!valid){
                 return;
               }

               if(activeButton===1){
                  quote_payload={
    "civilId":formData.Civil_ID,
    "plateNo": formData.Plate_Number,
    "registrationMark":formData.Plate_Code,
    "srcBusId": "SJET",
    "txnTyp":"Q",
    "mobileNo":"",
    "policyNo":"",
    "quoteNo":"",
    "searchTyp":"",
    "policy_type":"renewal",
    "sanad_details":sanadDetails
}

               }
               else if(activeButton===2){
                  quote_payload={
    "civilId":"",
    "plateNo": formData.Plate_Number,
    "registrationMark":formData.Plate_Code,
    "srcBusId": "SJET",
    "txnTyp":"Q",
    "mobileNo":formData.Mobile_Number,
    "policyNo":"",
    "quoteNo":"",
    "searchTyp":"",
    "policy_type":"renewal",
    "sanad_details":sanadDetails

}
               }
               else if(activeButton===3){
                 quote_payload={
    "civilId":"",
    "plateNo": "",
    "registrationMark":"",
    "srcBusId": "SJET",
    "txnTyp":"Q",
    "mobileNo":"",
    "policyNo":"",
    "quoteNo":formData.Quote_No,
    "searchTyp":"",
    "policy_type":"renewal",
    "sanad_details":sanadDetails
}
               }

               //api integration get Quote

               try{
                setLoading(true);

                const response = await fetch(`${base_url}/sanad_motor_search_quote`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${vendor_key}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(quote_payload),
      });

      if (!response.ok) {
        console.log("searching quote HTTP status:", response.status);
        return null;
      }

      const data = await response.json();
      debugger
      if(data.message==="success"){
      if (data?.result?.effectiveDt && data?.result?.insuredDetails) {
        setQuoteDetails(data.result);
        setVehicleDetails(data.result.vehicleDetails);
        setInsuredDetails(data.result.insuredDetails);
        setTransactionDetails(data.result.transactionDetails || null);
         setOpenQuoteSummary(true);
           setTimeout(()=>{

            if(quoteRef.current){
                quoteRef.current.scrollIntoView({block:"start",behavior:"smooth"});
            }},0);
      }
      else if(data.result?.transactionDetails?.errMsg || data.result?.errMsg){
         setMessage(data.result?.transactionDetails?.errMsg || data?.result?.errMsg);
            setOpenMessageBox(true);
      }
    }

               }catch(err){
                  console.error('Err at get Quote'+error)
               }
               finally{
                setLoading(false)
               }
             }
  const handleClose=()=>{
    setOpenMessageBox(false);
  }

    const handleCommunicationCheckBox=(e)=>{
  
      const {name,checked}=e.target;
      debugger
      //  if(!checked){
      //    setCommunicationError((prev)=>({
      //     ...prev,
      //      [name]:""
      //    }));
      //  }
  
      if(name==="sameAsMobile" && checked){
        setCommunicationDetails((prev)=>({
          ...prev,
         [name]:checked,
         whatsapp:communicationDetails.mobile
        }))
  
         setCommunicationError((prev)=>({
    ...prev,
      whatsapp:""
    }));
        
        return;
      }
      if(name==="sameAsMobile" && !checked){
        setCommunicationDetails((prev)=>({
          ...prev,
          [name]:checked,
          whatsapp:""
        }))
        return;
      }
     
      setCommunicationDetails((prev)=>({
        ...prev,
        [name]:checked
      }))
  
  
  
    }
  
    const handleBlurcommunicationfield=(e)=>{
  
    const error={
    mobile:"please enter mobile number",
    whatsapp:"please enter whatsapp number",
    email:"please enter email"
  }
  
      const {name,value}= e.target;
  
      const trimValue=value.trimStart();
      if(!value){
    setCommunicationError((prev)=>({...prev,[name]:error[name]}));
    return;
  }
  
  
  const errors={
    email:"Please enter a valid email address."
  }
  
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  
  if(emailPattern.test(trimValue)){
    setCommunicationError((prev)=>({...prev,email:""}));
  }
  else{
    setCommunicationError((prev)=>({...prev,email:errors[name]}));
  }
  
    }
  
    const handleCommunicationChange=(e)=>{
      const {name,value}=e.target;
  debugger
  
  const trimValue=value.trimStart();
  
  if(name==="mobile" || name ==="whatsapp"){
       const numberOnlyRegex = /^[0-9]*$/;
       if(numberOnlyRegex.test(trimValue)){
       setCommunicationDetails((prev)=>({
        ...prev,
        [name]:trimValue
      }));
  
       if(trimValue){
        setCommunicationError((prev)=>({...prev,[name]:""}));
      }
  
        if(communicationDetails.sameAsMobile && name==="mobile"){
  
        setCommunicationDetails((prev)=>({
          ...prev,
          whatsapp:trimValue,
          mobile:trimValue
        }) )
  
        setCommunicationError((prev)=>({...prev,
          whatsapp:""
        }))
        return;
      }
  
    }
    }
  else{
     setCommunicationDetails((prev)=>({
        ...prev,
        [name]:trimValue
      }));
  }
     
    
    }
  
  
  
  
  

  
    const handlePayment=async (e)=>{
      debugger
      e.preventDefault();
      try{
        setLoading(true);
  
      if(activePriceButton!==1){
        toast.error("Please select premium amount");
        return;
      }
  
      let valid =true;
      let first_field_error="";
  
      if(  !communicationDetails.mobile) {
        setCommunicationError((prev)=>({...prev,mobile:"Please enter mobile number"}));
        first_field_error="mobile";
        valid= false;
      }
  
        if(!communicationDetails.whatsapp){
        setCommunicationError((prev)=>({...prev,whatsapp:"Please enter whatsapp number"}));
        if(!first_field_error) first_field_error="whatsapp";
        valid=false;
      }
      
      if(communicationDetails.emailChecked && !communicationDetails.email){
        setCommunicationError((prev)=>({...prev,email:"Please enter email"}));
         if(!first_field_error)  first_field_error="email";
        valid = false ;
      }
       if(communicationDetails.emailChecked &&communicationDetails.email){
  
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  
  if(emailPattern.test(communicationDetails.email)){
    setCommunicationError((prev)=>({...prev,email:""}));
  }
  else{
        setCommunicationError((prev)=>({...prev,email:"Please enter a valid email address."}));
         if(!first_field_error)  first_field_error="email";
        valid = false ;
  }
      }
  
      if(first_field_error){
        if(com_refs[first_field_error] && com_refs[first_field_error].current){
          com_refs[first_field_error].current.focus();
        }
      }
       
  
      // confirmation Package api 
  if(valid){

  if(quoteDetails.packageDetails && quoteDetails.packageDetails.length>0){
  debugger
      const req_body_cpp={ 
      prodId: quoteDetails.prodId.substring(0,4),
      packageId:selectedPlan.$.id,
      planSelection:selectedPlan.planSelection,
      premiumAmount:selectedPlan.premiumAmt,
      obtainedCover:selectedPlan.obtainedCvr,
      quoteNo:quoteDetails?.renewalQuoteNo || transactionDetails?.quoteNo,
      srcBusId:"SJET"
   }
  
   const response = await fetch(base_url+"/sanad_confirm_package_plan",{
    method:"POST",
    headers:{
      "Authorization": `Bearer ${vendor_key}`,
      "Content-Type": "application/json"
    },
    body:JSON.stringify(req_body_cpp)
  });
  if(!response.ok){
    console.log("confirm package plan HTTP status :", response.status);
    }
  const data= await response.json();
  
  if(data.message==="success"){
  
    // setConfirmPackageDetails(data.result);
  }
    }
  
  
  
      //communication preference api 
  
  
  
      const communication_data ={
       
          "licenseNo": insuredDetails.insuredLicNo,  //civil id 
           "quoteNo": quoteDetails?.renewalQuoteNo || transactionDetails?.quoteNo,
            "agentCode": "Agent1",
          "emailId": communicationDetails.email || "",
                
         "mobileCountry": "968",  
          "mobileNo": communicationDetails.mobile, 
          "whatsappNo": communicationDetails.whatsapp
      }
      const response = await fetch(base_url+"/sanad_update_communication_prefer",{
    method:"POST",
    headers:{
      "Authorization": `Bearer ${vendor_key}`,
      "Content-Type": "application/json"
    },
    body:JSON.stringify(communication_data)
  });
  if(!response.ok){
    console.log("update communication prefer plan HTTP status :", response.status);
    }
  const data= await response.json();
  
  if(data.message==="success"){
  
    if(data.result.message==="S" || data.result.success){
  
  
      // payment api 
      const payment_data={
      "quoteNo":quoteDetails?.renewalQuoteNo || transactionDetails?.quoteNo,
      "amount": premiumAmount
  }
  
    const response = await fetch(base_url+"/sanad_motor_ins_payments",{
    method:"POST",
    headers:{
      "Authorization": `Bearer ${vendor_key}`,
      "Content-Type": "application/json"
    },
    body:JSON.stringify(payment_data)
  });
  if(!response.ok){
    console.log("payment fetch HTTP status :", response.status);
    }
  
    const payment_response = await response.json();
  
    if(payment_response.message==="success"){
  
      if(payment_response.result.success && payment_response.result.message==="Payment Link Generated Successfully" ){
  
        const url = payment_response.result.data
  
        if(url){
  
            window.location.href=url;
        }
  
      }
    }
    else{
      toast.error("Payment process not initiated");
    }
    } 
    }
  
    }
  }
  catch(err){
     console.error("err at ",err)
  }
  finally{
   setLoading(false);
  }
    }


     

  const handleHoverObtainCvr = (e, obtCvr) => {
    const cover_details = obtCvr.split(/,(?!\d)/);
    setHoveredCovers(cover_details);

    // position tooltip near the icon
    const rect = e.target.getBoundingClientRect();
    setTooltipPos({
  x: rect.left / 2,   // center X
  y: rect.bottom+10               // 10px above the element
});
    setShowTooltip(true);
  };

  const handleLeave = () => {
    setShowTooltip(false);
    setHoveredCovers([]);
  };
 
  
  
  return (
    <>
    {
    isHidePage === "success" ? (
        <Fragment>
      <div className="visa-form1">
      {/* <div> <h1>Motor Insurance</h1></div> */}
        <div className="inside_visa-form  shadow">
       
              <div className="row mb-4">
            <div className="col-lg-12">
              <div className="d-flex w-100 justify-content-between ">
             <h2>Renew Policy</h2>

              <h2>سياسة جديدة</h2>
              </div>
            </div>
          </div>

          <div className=" col-md-12  col-lg-6 p-0 mt-3">
            <div className="col-md-12 d-flex  p-0">
              <button
                className="col-md-4"
                style={{
                  padding: "10px 10px",
                  border: "1px solid #073e78",
                  borderRadius: "6px 0px 0px 6px",
                  backgroundColor: activeButton === 1 ? "#073e78" : "white",
                  color: activeButton === 1 ? " white" : "#073e78",
                }}
                onClick={() => handleClick(1)}
              >
                <div>Plate & Civil id</div>
              </button>
              <button
                className="col-md-4"
                style={{
                  padding: "10px 10px",
                  border: "1px solid #073e78",
                  borderRadius: "0px 0px 0px 0px",
                  backgroundColor: activeButton === 2 ? " #073e78" : "white",
                  color: activeButton === 2 ? " white" : "#073e78",
                }}
                onClick={() => handleClick(2)}
              >
                <div>Plate & Mobile No</div>
              </button>
              <button
                className="col-md-4"
                style={{
                  padding: "10px 10px",
                  border: "1px solid #073e78",
                  borderRadius: "0px 6px 6px 0px",
                  backgroundColor: activeButton === 3 ? " #073e78" : "white",
                  color: activeButton === 3 ? " white" : "#073e78",
                }}
                onClick={() => handleClick(3)}
              >
                <div>Quote No</div>
              </button>
            </div>

            {activeButton == 1 && (
              <>
                <div className="row mt-3">
                  <div className="col-md-6 mt-2">
                    <label
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span>
                        Plate Number <span style={{ color: "red" }}>*</span>
                      </span>
                      <span style={{ textAlign: "right", direction: "rtl" }}>
                        رقم اللوحة
                      </span>
                    </label>
                    <input type="text"
                      name="Plate_Number"
                      ref={refs.Plate_Number}
                className="form-control"
                value={formData?.Plate_Number}
                onChange={handleChange}
                onBlur={handleValidation} />
                 {error?.Plate_Number && (
                <span style={{ color: "red" }}>{error?.Plate_Number}</span>
              )}
                  </div>

                  <div className=" col-md-6 mt-2">
                    <label
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span>
                        Plate Code <span style={{ color: "red" }}>*</span>
                      </span>
                      <span style={{ textAlign: "right", direction: "rtl" }}>
                        رمز اللوحة{" "}
                      </span>
                    </label>
                      <select
                ref={selectOpt1}
                name="Plate_Code"
                className="form-control"
                value={formData?.Plate_Code}
                onChange={handleChange}
                onBlur={handleValidation}
              >
                <option value={null}>--select--</option>
                {reg_mark.map((option, index) => (
                  <option key={index} value={option}>
                    {option}
                  </option>
                ))}
              </select>
              {error?.Plate_Code && (
                <span style={{ color: "red" }}>{error?.Plate_Code}</span>
              )}
                  </div>

                  <div className=" col-md-6 mt-2">
                    <label
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span>
                        Civil ID/License Number
                        <span style={{ color: "red" }}> *</span>
                      </span>
                      <span style={{ textAlign: "right", direction: "rtl" }}>
                        رقم البطاقة المدنية/الرخصة
                      </span>
                    </label>
                    <input type="text"
                    name="Civil_ID"
                className="form-control"
                ref={refs.Civil_ID}
                value={formData?.Civil_ID}
                onChange={handleChange}
                onBlur={handleValidation}
                     />
                      {error?.Civil_ID && (
                <span style={{ color: "red" }}>{error?.Civil_ID}</span>
              )}
                  </div>
                </div>
              </>
            )}

            {activeButton == 2 && (
              <>
                <div className="row mt-3">
                  <div className=" col-md-6 mt-2 ">
                    <label
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span>
                        Plate Number<span style={{ color: "red" }}> *</span>
                      </span>
                      <span style={{ textAlign: "right", direction: "rtl" }}>
                        رقم اللوحة
                      </span>
                    </label>
                    <input type="text" 
                     name="Plate_Number"
                className="form-control"
                ref={refs.Plate_Number}
                value={formData?.Plate_Number}
                onChange={handleChange}
                onBlur={handleValidation}
                     />
                      {error?.Plate_Number && (
                <span style={{ color: "red" }}>{error?.Plate_Number}</span>
              )}
                  </div>

                  <div className=" col-md-6 mt-2 ">
                    <label
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span>
                        Plate Code<span style={{ color: "red" }}> *</span>
                      </span>
                      <span style={{ textAlign: "right", direction: "rtl" }}>
                        رمز اللوحة{" "}
                      </span>
                    </label>
                    <select
                ref={selectOpt1}
                name="Plate_Code"
                className="form-control"
                value={formData?.Plate_Code}
                onChange={handleChange}
                onBlur={handleValidation}
              >
                <option value={null}>--select--</option>
                {reg_mark.map((option, index) => (
                  <option key={index} value={option}>
                    {option}
                  </option>
                ))}
              </select>
              {error?.Plate_Code && (
                <span style={{ color: "red" }}>{error?.Plate_Code}</span>
              )}
                  </div>

                  <div className=" col-md-6 mt-2">
                    <label
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span>
                        Mobile Number<span style={{ color: "red" }}> *</span>
                      </span>
                      <span style={{ textAlign: "right", direction: "rtl" }}>
                        رقم الهاتف المحمول
                      </span>
                    </label>
                    <input type="text" name="Mobile_Number"
                className="form-control"
                ref={refs.Mobile_Number}
                value={formData?.Mobile_Number}
                onChange={handleChange}
                onBlur={handleValidation}
                     />
                      {error?.Mobile_Number && (
                <span style={{ color: "red" }}>{error?.Mobile_Number}</span>
              )} 
                  </div>
                </div>
               
              </>
            )}
            {activeButton == 3 && (
              <div className="col-md-6 p-0 mt-3">
                <div className=" p-0">
                  <label
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span>
                      Quote No<span style={{ color: "red" }}> *</span>
                    </span>
                    <span style={{ textAlign: "right", direction: "rtl" }}>
                      رقم الاقتباس
                    </span>
                  </label>
                  <input type="text"  
                  name="Quote_No"
                className="form-control"
                ref={refs.Quote_No}
                value={formData?.Quote_No}
                onChange={handleChange}
                onBlur={handleValidation}
                     />
                      {error?.Quote_No && (
                <span style={{ color: "red" }}>{error?.Quote_No}</span>
              )}
                </div>
                
              </div>
            )}

             <div>
                  <button className="mt-4" onClick={handleGetQuote}>GET QUOTE</button>
                </div>
          </div>
        </div>


            <div ref={quoteRef} ></div>
      
               {openQuoteSummary && (
                       <>
                         <div className="d-flex w-100 mt-5 mb-2 " >
                           <h2>Quote Summary</h2>
             
                         </div>
                         <div className="mb-4">
                           <div className="row d-flex ">
                             <div className="col-lg-6 mt-3">
                               <div className="d-flex justify-content-between ">
                                 <h3>Vehicle Details</h3>
                                 <h3>تفاصيل السيارة</h3>
                               </div>
                               <div className="card shadow w-100 ">
                                 <div className="  w-100">
                                   <div className="col-lg-12 mt-3 mb-1">
                                     <div className="border  d-flex flex-wrap p-3 align-items-center justify-content-between mb-2">
                                       <div>
                                         <h3 className=" p-0">{vehicleDetails.make} {vehicleDetails.model}</h3>
                                         <p className=" m-0">{vehicleDetails.manuYear}</p>
                                       </div>
                                       <div>
                                         <button>{vehicleDetails.vehRegNo} {vehicleDetails.vehRegLOC}</button>
                                       </div>
                                     </div>
                                   </div>
                                   <table className="w-100 mt-3">
                                     <tbody>
                                       <tr>
                                         <td style={{width:"40%"}}>
                                           <h5 className="pl-3">
                                             <strong>Chassis No</strong>
                                           </h5>
                                         </td>
                                         <td>
                                           <h5>: {vehicleDetails.chasisNo}</h5>
                                         </td>
                                       </tr>
             
                                       <tr>
                                         <td>
                                           <h5 className="pl-3">
                                             <strong>Body Type</strong>
                                           </h5>
                                         </td>
                                         <td>
                                           <h5>: {vehicleDetails.vehBody}</h5>
                                         </td>
                                       </tr>
             
                                       <tr>
                                         <td>
                                           <h5 className="pl-3">
                                             <strong>Usage Type</strong>
                                           </h5>
                                         </td>
                                         <td>
                                           <h5>: {vehicleDetails.usage}</h5>
                                         </td>
                                       </tr>
                                     </tbody>
                                   </table>
                                 </div>
                                 <div></div>
                               </div>
                             </div>
             
                             <div className="col-lg-6 mt-3">
                               <div className="d-flex justify-content-between ">
                                 <h3>Insured Details</h3>
                                 <h3>تفاصيل المؤمن عليه</h3>
                               </div>
                               <div className="w-100 ">
                                 <div className="card shadow w-100">
                                   <table className="w-100 mt-3">
                                     <tbody>
                                       <tr>
                                         <td>
                                           <h5 className="pl-3">
                                             <strong>Insured Name</strong>
                                           </h5>
                                         </td>
                                         <td>
                                           <h5>: {insuredDetails.insureFullName}</h5>
                                         </td>
                                       </tr>
             
                                       <tr>
                                         <td>
                                           <h5 className="pl-3">
                                             <strong>Civil Id / Lic No</strong>
                                           </h5>
                                         </td>
                                         <td>
                                           <h5>: {insuredDetails.insuredLicNo}</h5>
                                         </td>
                                       </tr>
             
                                       <tr>
                                         <td    style ={{width:"40%"}}>
                                           <h5 className="pl-3">
                                             <strong>Age</strong>
                                           </h5>
                                         </td>
                                         <td>
                                           <h5>: {insuredDetails.insuredAge}</h5>
                                         </td>
                                       </tr>
                                     </tbody>
                                   </table>
                                 </div>
                                 <div></div>
                               </div>
                             </div>
             
                             
             
                             {/* <div className=" p-3 mt-2">
                                 <h3>Communication Preference</h3>
                                 <div>
                                   <h5>Your Communication Preference and Consent</h5>
                                   <p>cdvnkkjvnjvjnvjjvjvnjv</p>
                                 </div>
             
                                 <div className="row">
                                   <div className="col-lg-6 mt-2">
                                     <label className="mb-0 mt-1 ">
                                       <input type="checkbox" /> Mobile Number
                                       <span style={{ color: "red" }}>*</span>
                                     </label>
                                     <input
                                       type="text"
                                       className="form-control"
                                     />
                                   </div>
                                   <div className="col-lg-6  mt-2">
                                     <div className="p-0 d-flex justify-content-between">
                                       <label className="mb-0 mt-1 ">
                                         <input
                                           type="checkbox"
                                           checked={isClickedWhatsapp}
                                           onClick={handleWhatsapp}
                                         />{" "}
                                         Whatsapp<span style={{ color: "red" }}>*</span>
                                       </label>
                                       {isClickedWhatsapp && (
                                         <div className="p-0 d-flex justify-content-center align-items-center ">
                                           <input type="checkbox" />
                                           <label
                                             className="mb-0 ml-1"
                                             style={{ fontSize: "8px" }}
                                           >
                                             Same as mobile no.
                                           </label>
                                         </div>
                                       )}
                                     </div>
                                     <input
                                       type="text"
                                       className="form-control"
                                     />
                                   </div>
                                   <div className="col-lg-6 mt-2">
                                     <label className="mb-0 mt-1 ">
                                       {" "}
                                       <input type="checkbox" /> Email
                                     </label>
                                     <input
                                       type="text"
                                       className="form-control"
                                     />
                                   </div>
                                 </div>
                               </div> 
             
             
              */}
              <div className="col-12 mt-3">
             <div className="row d-sm-flex flex-column-reverse flex-lg-row ">
              <div className="col-lg-6 ">
                               <div className="d-flex justify-content-between mt-3 ">
                                 <h3>Quote Details</h3>
                                 <h3>تفاصيل الاقتباس</h3>
                               </div>
                               <div className="w-100 ">
                                 <div className="card shadow w-100">
                                   <table className="w-100 mt-3">
                                     <tbody>
                                       <tr>
                                         <td style={{width:"40%"}}>
                                           <h5 className="pl-3">
                                             <strong>Quote No</strong>
                                           </h5>
                                         </td>
                                         <td>
                                           <h5>: {quoteDetails?.renewalQuoteNo || transactionDetails?.quoteNo}</h5>
                                         </td>
                                       </tr>
                                          {
                                        quoteDetails && quoteDetails?.previousPolicyNo ?
                                        <tr>
                                         <td>
                                        <h5 className="pl-3">
                                          <strong>Old Policy No</strong>
                                        </h5>
                                        </td>
                                          <td>
                                            <h5>: {quoteDetails?.previousPolicyNo}</h5>
                                          </td>
                                          </tr>
                                          :
                                          <></>
                                        }
                          
                                       <tr>
                                         <td>
                                           <h5 className="pl-3">
                                             <strong>Cover From Date</strong>
                                           </h5>
                                         </td>
                                         <td>
                                           <h5>: {quoteDetails?.effectiveDt.split(" ")[0]}</h5>
                                         </td>
                                       </tr>
             
                                       <tr>
                                         <td>
                                           <h5 className="pl-3">
                                             <strong>Cover To Date</strong>
                                           </h5>
                                         </td>
                                         <td>
                                           <h5>: {quoteDetails?.expirationDt.split(" ")[0]}</h5>
                                         </td>
                                       </tr>
             
                                       <tr>
                                         <td>
                                           <h5 className="pl-3">
                                             <strong>Product</strong>
                                           </h5>
                                         </td>
                                         <td>
                                           <h5>: {quoteDetails?.prodId}</h5>
                                         </td>
                                       </tr>
                                     </tbody>
                                   </table>
                                 </div>
                                 <div></div>
                               </div>
                               <div className="inside_visa-form shadow mt-4">
                               <h3>Select</h3>
             
             {
             (quoteDetails && quoteDetails.packageDetails && quoteDetails.packageDetails.length>0)?
             <>
             {quoteDetails.packageDetails.map((plan, index)=>(
               
                               <div className="mt-2" key={index}>
                       <button
                         className="col-lg-12"
                         name={plan.$.id}
                         style={{
                           border: "1px solid #204974",
                           backgroundColor: activePriceButton === index + 1 ? "#073e78" : "white",
                           color: activePriceButton === index + 1 ? "white" : "#073e78",
                         }}
                         onClick={() => handlePriceClick(index + 1, plan)}
                       >
                         <div className="d-md-flex justify-content-md-between p-0">
                           <div>
                             {plan.planSelection}
                             &nbsp;&nbsp;
                             <span
                               style={{ position: "relative", top: "3px", cursor: "pointer" }}
                               onMouseEnter={(e) => handleHoverObtainCvr(e, plan.obtainedCvr)}
                               onMouseLeave={handleLeave}
                             >
                               <svg
                                 xmlns="http://www.w3.org/2000/svg"
                                 width="16"
                                 height="16"
                                 fill="currentColor"
                                 className="bi bi-info-circle"
                                 viewBox="0 0 16 16"
                               >
                                 <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                                 <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                               </svg>
                             </span>
                           </div>
                           <div
                             style={{
                               fontWeight: "bolder",
                               color: activePriceButton === index + 1 ? "white" : "black",
                             }}
                           >
                             OMR {plan.premiumAmt}
                           </div>
                         </div>
                       </button>
                     </div>
                      ) )}
                               </>:
                               <>
              <div className="mt-2">
                                 <button
                                   className="col-lg-12 "
                                   style={{
                                     // padding: "10px 10px",
                                     border: "1px solid #073e78",
             
                                     backgroundColor:
                                       activePriceButton === 1 ? " #073e78" : "white",
                                     color: activePriceButton === 1 ? " white" : " #073e78",
                                   }}
                                   onClick={() => handlePriceClick(1,quoteDetails?.packageDetails.premiumAmt || quoteDetails?.premiumAmt)}
                                 >
             
                                   <div className="d-md-flex justify-content-md-between p-0">
                                     <div>{quoteDetails?.packageDetails?.planSelection || quoteDetails?.planSelection || "N/A"}
                                      &nbsp;
                                      &nbsp;
                                     <span style={{position:"relative",top:"3px", cursor: "pointer"}}
                                      onMouseEnter={(e) => handleHoverObtainCvr(e,quoteDetails?.packageDetails?.obtainedCvr ||  quoteDetails?.obtainedCvr)}
                               onMouseLeave={handleLeave}
                                     ><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
               <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
               <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
             </svg></span>
                                     </div>
                                     <div
                                       style={{
                                         fontWeight: "bolder",
                                         color: activePriceButton === 1 ? "white" : "black",
                                       }}
                                     >
                                       OMR {quoteDetails?.packageDetails?.premiumAmt||quoteDetails?.premiumAmt}
                                     </div>
                                   </div>
                                  </button>
                               </div>
                               </>
             }
                             {
                              obtainedCover &&
                              <>
                              <div className="mt-3">
                              <b>Benefits Covered : </b>{obtainedCover}
                              </div>  
                              </>
                             }
                                </div>

                                      <div className="card shadow py-3 px-3 mb-5 mt-3" >
                           {
                             activePriceButton > 0 && (
                            <>
                               <div>
                                 <span>NET PREMIUM</span>
                                 <span>(including VAT & all other taxes)</span>
                               </div>
             
                               <h2>OMR {premiumAmount}</h2>
                          </>
                           )}
                             <div className="mt-2">
                               <button type="button " onClick={(e)=>handlePayment(e)}  >PAY PREMIUM</button>
                             </div>
                           </div>
                             </div>
                             <div className="col-lg-6 ">
                             
                               <div className="d-flex justify-content-between mt-3 ">
                                 <h3>Communication Preference</h3>
                                 <h3>تفاصيل المؤمن عليه</h3>
                               </div>
             <div className="inside_visa-form shadow">
                               <div>
                                 <h5>Your Communication Preference and Consent</h5>
                                 <p className=" p-0" style={{textAlign:"justify"}}>
                                   Please select how you'd like to receive policy documents
                                   and communications. By choosing your preferred mode, you
                                   consent to receiving documents and related updates
                                   electronically. You can update these preferences anytime.
                                   Preferred Communication Mode (I consent for receiving
                                   policy documents, related updates and communications
                                   electronically)
                                 </p>
                               </div>
                     
                               <div className="row"> 
                                 <div className="col-lg-6 col-md-6 mt-3">
                                   <label
                                     style={{
                                       display: "flex",
                                       justifyContent: "space-between",
                                       alignItems: "center",
                                     }}
                                   >
                                     <span>
                                       {/* <input type="checkbox"
                                         style={{display: "inline-block",
                                                position: "relative",
                                                top: "2px"}}
                                                name="mobileChecked"
                                                  onChange={handleCommunicationCheckBox}
                                                  checked={communicationDetails.mobileChecked}  
                                                 />  */} Mobile Number
                                       <span style={{ color: "red" }}> *</span>
                                     </span>
                                     <span style={{ textAlign: "right", direction: "rtl" }}>
                                       رقم الهاتف المحمول
                                     </span>
                                   </label>
                                   <input type="text" 
                                   className="form-control" 
                                   ref={com_refs.mobile}
                                   value={communicationDetails.mobile}
                                   name="mobile"
                                   placeHolder="Enter your mobile number"
                                   onChange={handleCommunicationChange}
                                    onBlur={handleBlurcommunicationfield}
                                   />
                                 { communicationError?.mobile && (
                             <span style={{ color: "red" }}>{communicationError?.mobile}</span>
                           )}
                                 </div>
             
                                 <div className="col-lg-6 col-md-6 mt-3">
                                  <div className="d-flex justify-content-between">
                                     <span>
                                       {/* <input
                                         type="checkbox"
                                         onClick={handleWhatsapp}
                                          style={{display: "inline-block",
                                                position: "relative",
                                                top: "2px"}}
                                           name="whatsappChecked"
                                           onChange={handleCommunicationCheckBox}
                                           checked={communicationDetails.whatsappChecked} 
                                       />{" "} */}
                                       Whatsapp<span style={{ color: "red" }}> *</span>{" "}
                                       { 
                                         <span className="ml-1">
                                           <input type="checkbox" 
                                              style={{display: "inline-block",
                                                position: "relative",
                                                top: "2px"}} 
                                                name="sameAsMobile"
                                                 onChange={handleCommunicationCheckBox}
                                                 checked={communicationDetails.sameAsMobile}
                                                 
                                             
                                           />
                                           <span style={{ fontSize: "12px" }}>
                                             &nbsp;Same as mobile no.
                                           </span>
                                         </span>
                                       }
                                     </span>
                                     <span style={{ textAlign: "right", direction: "rtl" }}>
                                       واتس اب
                                     </span>
                                  </div>
             
             
                                   <input type="text" className="form-control" 
                                   name="whatsapp"
                                   placeHolder="Enter your whatsapp"
                                   ref={com_refs.whatsapp}
                                   value={communicationDetails.whatsapp}
                                   onChange={handleCommunicationChange}
                                   onBlur={handleBlurcommunicationfield}
                                    />
                                
                                      { communicationError?.whatsapp  && (
                             <span style={{ color: "red" }}>{communicationError?.whatsapp}</span>
                           )}
                                 </div>
                                 
                                 <div className="col-lg-6 col-md-6 mt-3">
                                  <div className="d-flex justify-content-between">
                                     <span>
                                       <input type="checkbox"
                                        style={{display: "inline-block",
                                                position: "relative",
                                                top: "2px"}} 
                                         name="emailChecked"
                                         onChange={handleCommunicationCheckBox}
                                         checked={communicationDetails.emailChecked}
                                       /> Email
                                     </span>
                                     <span style={{ textAlign: "right", direction: "rtl" }}>
                                       بريد إلكتروني
                                     </span>
                                   </div>
                                   <input type="text" 
                                   className="form-control" 
                                   name="email"
                                   ref={com_refs.email}
                                   value={communicationDetails.emailChecked?communicationDetails.email:""}
                                   onChange={handleCommunicationChange}
                                   onBlur={handleBlurcommunicationfield}
                                   placeHolder="Enter your email"
                                     disabled={communicationDetails.emailChecked?false:true} />
                                      {communicationDetails.emailChecked && communicationError?.email && (
                             <span style={{ color: "red" }}>{communicationError?.email}</span>
                           )}
                                 </div>
                                 
                               </div>
                               </div>
                             </div>
               </div>
              </div>
             
                            
                           </div>
             
                           <div className="row">
                            
                           
                            <div className="col-lg-6  mt-3 ">
                      
                           </div>
                           </div>
                         </div>
                       </>
                     )}
             
      </div>

  
      
        
      {
  openMessageBox  && (
        <div className='modal'>
          <div className='modal-content' style={{height: "auto" , width:'600px'}}>
         
          {/* <button type="button" className="close" onClick={handleClose}>
          &times;
          </button> */}
          
          <div>
          <div style={{textAlign:"left"}}>{message}</div>
          
          <hr></hr>
          <div>
          
          <button type="button" className="mt-3" aria-label="Close" onClick={handleClose}>Close</button>
          </div>

          </div>
          </div>
        </div>
      )
}
{showTooltip && (
        <div
          style={{
            position: "fixed",
            top: tooltipPos.y,
            left: tooltipPos.x,
            backgroundColor: "white",
            border: "1px solid #949494ff",
            // color:"white",
            padding: "8px",
            borderRadius: "5px",
            boxShadow: "0px 2px 8px rgba(0,0,0,0.15)",
            zIndex: 9999,
            maxWidth: "450px",
          }}
          
        >
          <ul style={{ margin: 0, paddingLeft: "20px" }}>
            {hoveredCovers.map((cvr, i) => (
              <li key={i}>{cvr.trim()}</li>
            ))}
          </ul>
        </div>
      )}
</Fragment>):
(
    <div
      style={{
        width: "100vw",
        height: "100vh",
        border: "none",
        textAlign: "center",
        marginTop: "25%",
        fontSize: "20px",
        fontWeight: "bold",
      }}
    >
      {" "}
      {isHidePage === "" ? "Loading" : "Token Invalid"}
    </div>
)
    }
    {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
       <ToastContainer
        position="top-right" // default
        autoClose={5000} // 3 sec
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="colored" // or "dark", "colored"
      />
    
    </>
  );
}

export default SanadMotorPolicyRenewal